import cookie from 'vue-cookies'
import FeatureFlagService from '@/shared/services/feature-flag.service'
import { convertStringToEnglishLetters } from '@/shared/lib/convertStringToEnglishLetters'
import { captureApiError } from '@/shared/lib/captureApiError'

function initState() {
  return {
    loadingSub: false,
    webWalletsDisableWithdrawToCardFlag: undefined,
    webWalletsKycRestrictions: undefined,
    hideZeroBalance: !!cookie.get('hideZeroBalance'), // Checkbox state on the Index page about hiding zero balances
    searchCoinOnIndexPage: '', // Content of search input on the index page, usually with coin title or description
    showProductActivationModal: false, // Modal for product not activated error
    productActivationModalType: null, // Type: 'product' or 'kyb'
  }
}

const state = initState()

const mutations = {
  SET_LOADING_SUB(state, payload) {
    state.loadingSub = payload
  },

  SET_FEATURE_FLAG(state, payload) {
    state.webWalletsDisableWithdrawToCardFlag =
      payload.webWalletsDisableWithdrawToCard
    state.webWalletsKycRestrictions = payload.webWalletsKycRestrictions
  },

  setSearchCoinOnIndexPage(state, payload) {
    state.searchCoinOnIndexPage = payload
  },

  setHideZeroBalance(state, payload) {
    state.hideZeroBalance = payload
  },

  setShowProductActivationModal(state, payload) {
    state.showProductActivationModal = payload
  },

  setProductActivationModalType(state, payload) {
    state.productActivationModalType = payload
  },
}

const actions = {
  SET_LOADING_SUB: ({ commit }, payload) => {
    commit('SET_LOADING_SUB', payload)
  },

  FeatureFlagService: async ({ commit }) => {
    try {
      const response = await FeatureFlagService.init('WALLETS')
      commit('SET_FEATURE_FLAG', {
        webWalletsDisableWithdrawToCard: response.isEnabled(
          'webWalletsDisableWithdrawToCard'
        ),
        webWalletsKycRestrictions: response.isEnabled(
          'webWalletsKycRestrictions'
        ),
      })
    } catch (error) {
      console.error('Error: ', error)
      captureApiError('FeatureFlagService', 'FeatureFlagService', error)
    }
  },

  toggleHideZeroBalance({ state, commit }) {
    commit('setHideZeroBalance', !state.hideZeroBalance)
    if (state.hideZeroBalance) {
      cookie.set('hideZeroBalance', true)
    } else {
      cookie.remove('hideZeroBalance')
    }
  },

  showProductActivationModal({ commit }, type = 'product') {
    commit('setProductActivationModalType', type)
    commit('setShowProductActivationModal', true)
  },

  hideProductActivationModal({ commit }) {
    commit('setShowProductActivationModal', false)
    commit('setProductActivationModalType', null)
  },
}

const getters = {
  searchCoinConvertedToEnglishLetters(state) {
    return convertStringToEnglishLetters(state.searchCoinOnIndexPage)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
